export function getAdminPanelOrigin() {
  if (process.env.REACT_APP_ADMIN_URL) {
    return String(process.env.REACT_APP_ADMIN_URL).replace(/\/$/, "");
  }
  if (process.env.REACT_APP_Environment === "development") {
    return "http://localhost:3000";
  }
  return "https://admin.pondstat.com";
}

/** Open AdminPanel as a staff/owner user (legacy JWT switch). */
export function openAdminPanelAsUser(session) {
  const payload = encodeURIComponent(
    JSON.stringify({
      token: session.token,
      refreshToken: session.refreshToken,
      User: session.User,
    })
  );
  const url = `${getAdminPanelOrigin()}/user/admin-handoff#${payload}`;
  window.open(url, "_blank", "noopener,noreferrer");
}

/**
 * Open AdminPanel keeping the Super session, scoped to a pond-owner accountId.
 */
export function openAdminPanelWithAccountScope({ token, refreshToken, User, accountId, accountName, accountEmail }) {
  if (!token || !User || accountId == null) {
    throw new Error("Missing Super session or accountId");
  }
  const payload = encodeURIComponent(
    JSON.stringify({
      token,
      refreshToken: refreshToken || null,
      User: { ...User, isSuperUser: true },
      accountId: Number(accountId),
      accountName: accountName || null,
      accountEmail: accountEmail || null,
    })
  );
  const url = `${getAdminPanelOrigin()}/user/admin-handoff#${payload}`;
  window.open(url, "_blank", "noopener,noreferrer");
}
